/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYoutubeIcon24Solid = forwardRef('LogoYoutubeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.836 6.39C2 7.422 2 8.948 2 12c0 3.052 0 4.578.836 5.61.165.204.35.39.554.554C4.422 19 5.948 19 9 19h6c3.052 0 4.578 0 5.61-.836.204-.165.39-.35.554-.554C22 16.578 22 15.052 22 12c0-3.052 0-4.578-.836-5.61a3.752 3.752 0 0 0-.554-.554C19.578 5 18.052 5 15 5H9c-3.052 0-4.578 0-5.61.836a3.75 3.75 0 0 0-.554.554ZM16 12l-6 3.39V8.61L16 12Z" })));
});
